export function stickyNav() {
  const headerHt = document.querySelector("#header").offsetHeight;

  const maybeAddSubmenuScrollbar = function () {
    const subMenu = document.querySelector("#menu-item-120 .sub-menu");
    const subMenuBox = document
      .querySelector("#menu-item-120 .sub-menu > :last-child")
      .getBoundingClientRect();
    if (
      subMenuBox.top + subMenuBox.height + subMenuBox.bottom >
      window.innerHeight
    ) {
      console.log("adding");
      subMenu.style.height = `${window.innerHeight}px`;
      subMenu.style.paddingBottom = `${headerHt}px`;
      subMenu.style.overflowY = "scroll";

      return true;
    }

    return false;
  };

  const maybeRemoveSubmenuScrollbar = function () {
    const subMenu = document.querySelector("#menu-item-120 .sub-menu");
    const subMenuBox = document
      .querySelector("#menu-item-120 .sub-menu > :last-child")
      .getBoundingClientRect();

    if (
      subMenuBox.top + subMenuBox.height + subMenuBox.bottom <=
      window.innerHeight
    ) {
      console.log("removing");
      subMenu.style.removeProperty("height");
      subMenu.style.removeProperty("padding-bottom");
      subMenu.style.removeProperty("overflow-y");

      return true;
    }

    return false;
  };

  const toggleStickyHeader = function () {
    /**
     * Get scroll position
     * @type {number}
     */
    let offset = window.pageYOffset;

    /**
     * Class name for sticky header
     * @type {string}
     */
    let sticky_class = "header-sticky";

    /**
     * Target node
     * @type {string}
     */
    let target = "body";

    /**
     * Target offest for the function to act on
     * @type {number}
     */
    let target_offset = 400;

    // console.log(
    //   offset,
    //   target_offset,
    //   document.querySelector(target).classList
    // );

    if (
      offset > target_offset &&
      !document.querySelector(target).classList.contains(sticky_class)
    ) {
      document.querySelector(target).classList.add(sticky_class);

      return "added";
    } else if (
      offset < target_offset &&
      document.querySelector(target).classList.contains(sticky_class)
    ) {
      document.querySelector(target).classList.remove(sticky_class);

      return "removed";
    }

    return false;
  };

  /**
   * Sticky nav
   */
  window.addEventListener("scroll", (e) => {
    /**
     * If screen is smaller than 991px wide, don't do this
     */
    if (window.innerWidth <= 991) return;

    const toggled = toggleStickyHeader();

    if (toggled === "added") {
      maybeAddSubmenuScrollbar();
    } else if (toggled === "removed") {
      maybeRemoveSubmenuScrollbar();
    }
  });

  /**
   * Sticky nav
   */
  window.addEventListener("resize", (e) => {
    /**
     * If screen is smaller than 991px wide, don't do this
     */
    if (window.innerWidth <= 991) return;

    if (maybeAddSubmenuScrollbar()) {
      return;
    }

    maybeRemoveSubmenuScrollbar();
  });
}
